module.exports = __webpack_public_path__ + "static/media/home-mask-sm.c5618cbc.png";